import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BasePackagingComponent } from '../_base-packaging.component';


@Component({
  moduleId: module.id,
  selector: 'extended-information',
  templateUrl: 'extended-information.component.html',
  styleUrls: ['extended-information.component.scss'],
})
export class ExtendedInformationComponent extends BasePackagingComponent {

  @Input() declare itemDetailsData: any;

  @Input() declare data: Array<any>;

  @Input() formGroup: UntypedFormGroup;

  fullSizeFields: Array<string> = [
    'RCS.EN', 'RCT.EN'
  ];

  cellSize(item_name: string): string {
    return _.includes(this.fullSizeFields, item_name) ? 'size-full' : 'size-half';
  }
}
